import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import Sidebar from './Sidebar'
import Header from './Header'
import Footer from './Footer'
import { GrooveWidget } from '../Widgets'

const GlobalLayout = (props) => {
  const { isAuthenticated, user } = useSelector(state => state.auth) || {}
  const { roles } = user || {}
  const { isFetched } = useSelector(state => state.initial)

  if (isAuthenticated && isFetched && roles) {
    return (
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <Sidebar />
        <Box component='main' sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
          <Header />
          <Box sx={{ flex: 1, pt: '98px', px: '10px' }}>
            {props.children}
          </Box>
          <Footer />
        </Box>
        <GrooveWidget roles={roles} />
      </Box>
    )
  } else {
    return null
  }
}

export default GlobalLayout
